// src/TabContext.tsx
import React, { createContext, useState, useContext } from 'react';

type TabId = string;

interface TabContextValue {
  activeTab: TabId;
  setActiveTab: React.Dispatch<React.SetStateAction<TabId>>;
}

const TabContext = createContext<TabContextValue>({
  activeTab: 'overview',
  setActiveTab: () => {},
});

interface TabProviderProps {
  children: React.ReactNode;
}

export const TabProvider = ({ children }: TabProviderProps) => {
  const [activeTab, setActiveTab] = useState<TabId>('overview');

  return <TabContext.Provider value={{ activeTab, setActiveTab }}>{children}</TabContext.Provider>;
};

export const useTab = (): TabContextValue => useContext(TabContext);
